import React from 'react';
import CompletableTable from '../components/CompletableTable';

function IndexRoute() {
  return <CompletableTable />;
}

export default IndexRoute;
